import { render } from "./markdown-editor.vue?vue&type=template&id=22b9f6c2"
import script from "./markdown-editor.vue?vue&type=script&lang=js"
export * from "./markdown-editor.vue?vue&type=script&lang=js"
script.render = render

export default script